import React, {Fragment} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {browserHistory} from "react-router";
import Popup from 'components/popups/popup';
import I18n from 'lib/i18n/i18n';
import WorthyApiErrors from "lib/api/worthyApiErrors";
import UserActions from "lib/userActions";
import {dollarsWithoutCents} from 'helpers/ApplicationHelper';
import {acceptBundleSale} from 'actions/myAccount';

class PopupJBGetPaid extends Popup {
    static initPopup(props = {}) {
        Popup.initPopup.bind(this)(props);
    }

    constructor(props) {
        super(props);

        this.approve = this.approve.bind(this);
    }

    componentDidMount() {
        UserActions.myAccount('JB get paid popup presented', this.props.bundleId, 'Bundle');
    }

    title() {
        return I18n.getString('myAccount::popups::getPaid::title');
    }

    _hide() {
        UserActions.myAccount('JB get paid popup closed', this.props.bundleId, 'Bundle');
        super._hide();
    }

    content() {
        return (
            <Fragment>
                <p>
                    {I18n.getJsx(`myAccount::popups::getPaid::text::${this.props.paymentDetails.transfer_type}`, {
                        totalValue: <b>{dollarsWithoutCents(this.props.totalValue)}</b>,
                        feesRate: <span>{this.props.feesRate}%</span>
                    })}
                </p>
                <div className='payment-details'>
                    {I18n.getJsx(`myAccount::popups::getPaid::paymentDetails::${this.props.paymentDetails.transfer_type}`, this.paymentDetailsReplacements)}
                </div>
                <button className='cta' ref='approveBtn' onClick={this.approve}>{I18n.getString('myAccount::popups::getPaid::cta')}</button>
                <div className='after-cta'>{I18n.getString('myAccount::popups::getPaid::afterCta')}</div>
            </Fragment>
        )
    }

    get paymentDetailsReplacements() {
        switch(this.props.paymentDetails.transfer_type) {
            case 'paypal':
                return {
                    paypalUser: <div>{this.props.paymentDetails.paypal}</div>
                }
            case 'bank_transfer':
                return {
                    accountNumber: <span>{this.props.paymentDetails.bank.account_number}</span>,
                    bankName: <div>{this.props.paymentDetails.bank.bank_name}</div>
                }
        }
        return {};
    }

    approve() {
        this.refs.approveBtn.setAttribute("disabled", "disabled");
        this.props.acceptBundleSale(this.props.bundleId).then((res) => {
            if (res.payload instanceof WorthyApiErrors) {
                alert('Failed to create transfer for the bundle');
                this._hide();
            }
            else {
                UserActions.myAccount('JB get paid popup approved', this.props.bundleId, 'Bundle');
                this._hide();
                if (this.props.returnUrl) browserHistory.push(this.props.returnUrl);
                UserActions.myAccount('My items after deal approval page presented', this.props.bundleId, 'Bundle');
            }
        });
    }
}
PopupJBGetPaid.defaultProps = {
    popupClassName: 'popup-jb-get-paid popup-compact popup-tooltip',
    single: true,
    modal: true,
    classNames: ['no-animation']
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({acceptBundleSale}, dispatch);
};

export default connect(null, mapDispatchToProps)(PopupJBGetPaid);